import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import ZoneChecker from '../components/common/ZoneChecker';

export default function ContactPage() {
  return (
    <div style={{ background: 'var(--bg, #FBF7F1)', minHeight: '100vh' }}>
      <Header />
      <div className="container-ose section-py">
        <h1 className="font-display text-3xl font-bold mb-2" style={{ color: 'var(--text)', letterSpacing: '-0.02em' }}>Contactez-nous</h1>
        <p className="text-sm mb-12" style={{ color: 'var(--text-muted)' }}>Notre équipe est disponible pour répondre à vos questions</p>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-6">
            {[
              { icon: <Phone size={20} />, label: 'Téléphone', value: '07 56 87 66 65', href: 'tel:0756876665' },
              { icon: <Mail size={20} />, label: 'Email', value: 'showevenementiel@gmail.com', href: 'mailto:showevenementiel@gmail.com' },
              { icon: <MapPin size={20} />, label: 'Zone d’intervention', value: 'Rayon 1h30 autour de Figeac — Lot (46), Aveyron, Cantal, Corrèze' },
            ].map((c, i) => (
              <div key={`list-${i}`} className="flex items-start gap-4 p-5 rounded-xl" style={{ background: '#FFFFFF', border: '1px solid var(--border)' }}>
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: 'rgba(212,175,55,0.12)', color: '#D4AF37' }}>{c.icon}</div>
                <div>
                  <p className="text-xs mb-0.5" style={{ color: 'rgba(26,26,46,0.5)' }}>{c.label}</p>
                  {c.href ? <a href={c.href} className="text-sm font-medium" style={{ color: 'var(--ink)' }}>{c.value}</a> : <p className="text-sm font-medium" style={{ color: 'var(--ink)' }}>{c.value}</p>}
                </div>
              </div>
            ))}
          </div>
          <div className="p-6 rounded-xl" style={{ background: '#FFFFFF', border: '1px solid var(--border)' }}>
            <h2 className="font-semibold mb-4" style={{ color: 'var(--teal)' }}>Ou créez directement votre devis</h2>
            <p className="text-sm mb-6" style={{ color: 'rgba(255,255,255,0.55)' }}>Utilisez notre configurateur pour obtenir un devis instantané en 2 minutes.</p>
            <Link to="/creer-evenement" className="btn-gold px-5 py-3 rounded-xl text-sm font-semibold flex items-center gap-2">
              Créer mon événement <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
